/*
 * Sticky "Sepete ekle" -> TEPO köprüsü
 * ------------------------------------
 * Minimog'un stok dosyası DEĞİLDİR — RimaPeçete'ye özel eklendi.
 *
 * Temanın yapışkan sepet çubuğu kendi formunu gönderir. TEPO (Qikify
 * Product Options) ise yalnız ana ürün formuna bağlanır: temanın butonunu
 * gizler, üstüne kendi butonunu (name="tcustomizer-add") koyar ve zorunlu
 * alanları (isim bilgisi, onay kutusu) tıklamada denetler.
 *
 * Bu köprü olmadan yapışkan çubuktan eklenen ürün kişiselleştirme
 * bilgisi OLMADAN sepete girer. Bu yüzden:
 *   - sayfada TEPO butonu varsa yapışkan çubuğun tıklaması engellenir,
 *   - sayfa kişiselleştirme formuna kaydırılır,
 *   - TEPO'nun kendi butonu tıklanır → doğrulama ve ekleme TEPO'da kalır.
 * TEPO butonu yoksa (seçeneksiz ürün) temanın kendi akışına dokunulmaz.
 */
(function () {
  var TEPO_BUTTON = '.m-product-form--main button[name="tcustomizer-add"]';
  var STICKY_BUTTON = '.m-sticky-addtocart .m-add-to-cart';
  var SCROLL_TARGETS = ['.tcustomizer-customization-form', '.m-product-form--main'];

  function scrollTarget() {
    for (var i = 0; i < SCROLL_TARGETS.length; i++) {
      var el = document.querySelector(SCROLL_TARGETS[i]);
      if (el) return el;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var stickyButton = event.target.closest(STICKY_BUTTON);
      if (!stickyButton) return;

      var tepoButton = document.querySelector(TEPO_BUTTON);
      if (!tepoButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var target = scrollTarget();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target) {
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }

      // Kaydırma bittikten sonra tıkla ki hata mesajı görünür alanda çıksın.
      window.setTimeout(function () {
        tepoButton.click();
      }, reduce ? 50 : 450);
    },
    true
  );
})();
